import { ValueSetSearchParams } from '@quromedical/models';
import { trpc } from 'trpc';

export class ValueSetApi {
  getIcd10Codes = async (params: ValueSetSearchParams = {}) =>
    trpc.client.icd10.getAll.query(params);
}
